import React from "react";
import { Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import MobileHome from "../pages/mobile/MobileHome";
import { ResponsivePage, useIsMobile } from "./mobile/DesktopOnlyScreen";
import { useAuth } from "../contexts/AuthContext";

// Route at "/" — technicians get redirected to their mobile home on phones,
// or to Jobs (desktop-ready) on desktop/tablet; everyone else sees the
// dispatcher Dashboard (mobile-redesigned layout on small viewports).
export default function RoleHome() {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  if (user && user !== false && user.role === "super_admin") {
    return <Navigate to="/platform" replace />;
  }
  if (user && user !== false && user.role === "technician") {
    return <Navigate to={isMobile ? "/mobile" : "/jobs"} replace />;
  }
  return <ResponsivePage mobile={<MobileHome />} desktop={<Dashboard />} />;
}
